export default function Datenschutz() {
    return (
        <section className="datenschutz" id="datenschutz">
            <div className="container">
                <h1>Datenschutzerklärung</h1>

                <p>
                    Der Schutz Ihrer persönlichen Daten ist uns wichtig. Auf dieser Website werden keine
                    personenbezogenen Daten erhoben oder gespeichert, da es keine Kontaktformulare,
                    Newsletter oder Benutzerkonten gibt.
                </p>

                <h2>Nutzung von Social-Media-Links</h2>
                <p>Unsere Website enthält Links zu unseren Facebook- und Instagram-Seiten. Bitte beachten Sie:</p>
                <ul>
                    <li>
                        Wenn Sie auf diese Links klicken und unsere Social-Media-Seiten besuchen, werden Daten
                        direkt von diesen Plattformen verarbeitet.
                    </li>
                    <li>
                        Wir haben keinen Einfluss auf die Erhebung und Verarbeitung von Daten durch Facebook
                        oder Instagram.
                    </li>
                </ul>
                <p>Weitere Informationen finden Sie in den Datenschutzrichtlinien der jeweiligen Anbieter:</p>
                <ul>
                    <li>
                        Facebook:{' '}
                        <a href="https://www.facebook.com/about/privacy" target="_blank" rel="noopener noreferrer">
                            https://www.facebook.com/about/privacy
                        </a>
                    </li>
                    <li>
                        Instagram:{' '}
                        <a href="https://help.instagram.com/519522125107875" target="_blank" rel="noopener noreferrer">
                            https://help.instagram.com/519522125107875
                        </a>
                    </li>
                </ul>

                <h2>Cookies</h2>
                <p>Diese Website setzt keine Cookies, die personenbezogene Daten erfassen.</p>
                <p>
                    Technisch notwendige Browser-Cookies für das Laden der Seite können verwendet werden,
                    enthalten jedoch keine personenbezogenen Daten.
                </p>

                <h2>Ihre Rechte</h2>
                <p>
                    Da wir keine personenbezogenen Daten erheben, gibt es aktuell keine Rechte auf Auskunft,
                    Berichtigung oder Löschung im Rahmen dieser Website.
                </p>

                <h2>Kontakt</h2>
                <p>
                    Bei Fragen zum Datenschutz können Sie uns unter:<br />
                    grooming.lajolie@gmail.com kontaktieren.
                </p>
            </div>
        </section>
    );
}
